import React from 'react'

const TypographyContext = React.createContext({})
export const TypographyProvider = TypographyContext.Provider
export default TypographyContext
